export enum ListRendererBreakpoints {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}
